import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { Box, Divider, IconButton, Paper, Tooltip, Typography, Switch } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import Theme from '../../../Themes/main.theme';
import TableGridWithFilters from '../../../components/TablegridWithFilters/TableGridWithFilters/TableGridWithFilters';
import HttpService from '../../../services/HttpService';
import { useSnackbar } from 'notistack';
import DialogAction from '../../../components/Dialog/DialogAction';
import AsyncBackdropSubmit from '../../../components/AsyncBackdropSubmit';

const ForeasDashboard = () => {
  document.title = 'Διαχείριση Φορέων';

  const [open, setOpen] = React.useState(false);
  const [status, setStatus] = React.useState({ id: null, is_published: false });
  const [refetch, setRefetch] = React.useState(false);
  const [onChangeLoading, setOnChangeLoading] = React.useState<boolean>(false);

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const onChangeOrganisation = async (id: number | null) => {
    setOnChangeLoading(true);
    try {
      const resp = await HttpService.getAxiosClient().patch(`${process.env.REACT_APP_BACKEND_URL}/foreas/${id}`, {
        is_published: status.is_published
      });
      if (resp.status === 200) {
        enqueueSnackbar('Επιτυχής αλλαγή κατάστασης του Φορέα', { variant: 'success' });
        setRefetch(!refetch);
      }
      setOnChangeLoading(false);
    } catch (error) {
      console.error(error);
      setOnChangeLoading(false);
      enqueueSnackbar('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.', { variant: 'error' });
    }
  };


  const columns: GridColDef[] = [
    {
      field: 'title',
      headerName: 'Τίτλος Καταχώρισης',
      minWidth: 920,
      sortable: true,
      renderCell: ({row}) => row?.['organisations:organisationsName']?.[0]?.['@value']
    },
    {
      field: 'isPublished',
      headerName: 'Publish / Unpublish',
      sortable: true,
      minWidth: 180,
      renderCell: ({ row }) =>
        <Switch
          checked={row['o:is_public']}
          onClick={(e:any) => {
            e.preventDefault();
            setOpen(true);
            setStatus({
              id: row['o:id'],
              is_published: !row['o:is_public']
            });
          }} />
    },
    {
      field: 'info',
      headerName: 'Ενέργεια',
      minWidth: 85,
      sortable: false,
      renderCell: ({row}) => 
        <>
          <Tooltip PopperProps={{
            disablePortal: true
          }} title={'Επεξεργασία Φορέα'}>
            <IconButton
              color='primary' 
              onClick={() => navigate(`/admin/organisation/${row['o:id']}/edit`)}>
              <EditIcon/>
            </IconButton>
          </Tooltip>
        </>
    }
  ];

  return (
    <>      
      <AsyncBackdropSubmit isLoading={onChangeLoading}>
        Παρακαλώ περιμένετε μέχρι να ολοκληρωθεί η διαδικασία...
      </AsyncBackdropSubmit>
      <Typography sx={{ my: 1, mt: 4 }} variant='h2' 
        color={Theme?.labelColor?.main}> Διαχείριση Φορέων </Typography>
      <Divider sx={{mb: 5, border: 1, color: Theme?.dividerColor?.main}}/>
      <Box mt={5} minWidth={350}>
        <Paper variant='outlined' 
          sx={{ height: 'fit-content', borderRadius: 2, boxShadow: 0, backgroundColor: 'transparent'}}>
          <Typography m={2} variant='h3'> Αιτήματα </Typography>
          <Box m={1} >
            <TableGridWithFilters
              pageSize={15}
              rowsPerPageOptions={[15, 30, 45]}
              sortingMode='server'
              paginationMode='server'
              responseDataFieldName='data'
              responseTotalCountFieldName = 'totalResults'
              hideFilters
              columns={columns}
              reFetch={refetch}
              fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/foreas`}
            />        
          </Box> 
          <DialogAction
            open={open} title={'Αλλαγή Κατάστασης'}
            handleClose={() => {
              setOpen(false);
            }}
            content='Είστε σίγουρος/η ότι θέλετε να αλλάξετε την κατάσταση;'
            onAccept={() => {
              onChangeOrganisation(status.id);
              setOpen(false);
            }} />
        </Paper>    
      </Box>
      
    </>
  );
};

export default ForeasDashboard;